module.exports = {
  BASE_URI: '/api'
}



//////////////////
// WEBPACK FOOTER
// ./config/dev.uri.js
// module id = HBXB
// module chunks = 238